import React from "react";
import { GridFooterContainer, GridPagination } from "@mui/x-data-grid-pro";
import { Box, Link, Typography } from "@mui/material";

function CustomFooter() {
  return (
    <GridFooterContainer
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 2,
      }}
    >
      <Box>
          <Link
            href="https://doimspp.sharepoint.com/sites/usgs-Integrated-Water-Science-Data-Management?CT=1635348264752&OR=OWA-NT&CID=9f60809f-05d9-072b-4c25-69e759af15bc "
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: (theme) => theme.palette.secondary.main,
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            Documentation on how to use this page
          </Link>
      </Box>
      <GridPagination />
    </GridFooterContainer>
  );
}

export default CustomFooter;
